export default "__VITE_PUBLIC_ASSET__5e96b9b2__"